import Image, { StaticImageData } from "next/image";
import Heading from "../atoms/Heading";
import { SectionHeadingType } from "../atoms/SectionHeading";

export type FeatureCardsSectionPropType = {
  title: SectionHeadingType;
  description: string;
  steps: {
    image: StaticImageData;
    text: string;
    description: string;
  }[];
};

const FeatureCardsSection = ({
  title,
  description,
  steps,
}: FeatureCardsSectionPropType) => {
  return (
    <div className="container flex flex-col gap-6 sm:gap-8">
      <div className="flex flex-col gap-2 sm:text-center">
        <Heading
          heading={title}
          fontStyle="text-title-20 sm:text-title-32"
          as="h2"
        />
        <p className="text-body-14 text-grey-3">{description}</p>
      </div>

      <div className="flex flex-col gap-4 sm:flex-row sm:gap-6">
        {steps.map((step, index) => {
          return (
            <div
              className="flex flex-1 flex-col items-start gap-1 rounded-2xl bg-purple-0 p-4 text-grey-4"
              key={index}
            >
              <div className="flex items-center justify-center">
                <Image src={step.image} alt={step.text} />
              </div>
              <h4 className="text-title-16">{step.text}</h4>
              <p className="text-body-12">{step.description}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FeatureCardsSection;
